import { initializeApp } from 'firebase/app';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore TODO: make a getter that validates env variables
export const app = initializeApp({ ...JSON.parse(process.env.NEXT_PUBLIC_FIREBASE_CONFIG), measurementId: undefined });
